/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import { useTranslation } from 'react-i18next';
import SummaryCard from '../../common/SummaryCard/SummaryCard';
import { actionTypes } from '../../common/SummaryCard/CardContext';

const useStyles = makeStyles(() => {
  return {
    cardMaxWidth: {
      maxWidth: 'unset',
    },
  };
});

export default function PartiesCard({ partiesEntries, isSummary, readOnly, submission, onSectionChange, cardTitle }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <SummaryCard
      Icon={AccountBoxIcon}
      cardTitle={cardTitle ?? t('parties')}
      subheader=""
      entries={partiesEntries}
      sectionName="submission_parties"
      actionType={isSummary ? null : actionTypes.SUMMARY}
      isSummary={isSummary}
      readOnly={readOnly}
      className={classes}
      submission={submission}
      onSectionChange={onSectionChange}
    />
  );
}
